import { render } from "./ModalDownload.vue?vue&type=template&id=5d66d361&scoped=true"
import script from "./ModalDownload.vue?vue&type=script&lang=js"
export * from "./ModalDownload.vue?vue&type=script&lang=js"

import "./ModalDownload.vue?vue&type=style&index=0&id=5d66d361&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d66d361"]])

export default __exports__